import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ISMSPolicyStatement = () => {
  return (
    <div id="isms-quality">
      <Navbar />
      <div className="isms-quality-intro">
        <div className="iso-quality-intro-container">
          <div className="iso-quality-intro-content">
            <h1>
              <span>ISMS </span>POLICY STATEMENT
            </h1>
          </div>
        </div>
      </div>

      <main>
        <section className="quality-policy-statement">
          <h4>
            <span>OUTCESS </span>INFORMATION SECURITY POLICY STATEMENT
          </h4>
          <p>
            At Outcess Solutions, we recognize the importance of protecting our customers’ 
            sensitive information and ensuring the confidentiality, integrity and availability 
            of our systems and data.{" "}
          </p>
          <p>
            Our information security policy is designed to{" "}
          </p>
          <ol>
            <li>
              <span>Protect Customer Data: </span>We are committed to safeguarding our customers’ 
              personal information from unauthorized access, 
              disclosure and theft
            </li>

            <li>
              <span>Ensure Business Continuity: </span> we will maintain business continuity 
              plans to minimize the impact of security incidents or disruptions on our operations.
            </li>
            <li>
              <span>Maintain System Integrity: </span>
              we have implemented robust security controls to prevent 
              unauthorized access, modification, or destruction of our systems and data.
            </li>
            <li>
              <span>4.	Continuous Improvement: </span>
              We are dedicated to continuously improving our processes, systems, and skills 
              to enhance the security and quality of our services. We encourage feedback from 
              both our customers and employees to identify areas for improvement and implement 
              appropriate actions.
            </li>
            <li>
              <span>Excellence in Communication: </span>
              We value effective and clear communication with our customers. Our agents are trained 
              to actively listen, communicate professionally, and provide accurate information, 
              ensuring that our customers receive the assistance they need promptly and courteously.
            </li>
            <li>
              <span>Performance Monitoring and Measurement: </span>
              We employ robust monitoring and measurement mechanisms to assess the performance 
              of our operations.
            </li>
            <li>
              <span>Training and Development:</span>
              We invest in the development and training of our employees to equip them with the 
              necessary skills, knowledge, and tools to deliver exceptional service and understand 
              their roles and responsibilities in maintaining information security.
            </li>
            <li>
              <span>Compliance with Regulations:</span>
              We adhere to all relevant laws, regulations, and industry standards related to 
              information security to ensure data security, privacy, and confidentiality.
            </li>
          </ol>
          <p>
          This Information Security Policy sets the foundation for our Call Center / Contact Center 
          operations and serves as a guide for all employees and other interested parties. We are 
          dedicated to upholding these principles, meeting our security objectives, and protecting 
          our customers’ sensitive information and maintaining the trust and confidence of our 
          stakeholders.
          </p>

          {/* <div className="date-and-signature">
            <div className="signature">
              <img src={signature} alt=""></img>
              <p>IKENNA ODIKE</p>
              <p>CHIEF EXECUTIVE OFFICER</p>
            </div>
            <div className="date">
              <p>____ 23-08-2022 ____</p>
              <p style={{textAlign:"center"}}>DATE</p>
            </div>
          </div> */}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ISMSPolicyStatement;
